"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.regexPassword = void 0;
exports.regexPassword = new RegExp(/^(?=.*\d)\S{5,}$/);
